import { createContext, useContext } from 'react';

/** Fuseau du garage renvoyé par la vue portail : les dates s'affichent comme le garage les a fixées. */
export const TimezoneContext = createContext<string | undefined>(undefined);

export function useTz(): string | undefined {
  return useContext(TimezoneContext);
}
